/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');



window.Vue = require('vue');


import Quasar from 'quasar';
Vue.use(Quasar);
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Vue.component(
//     'passport-clients',
//     require('./components/passport/Clients.vue').default
// );

// Vue.component(
//     'passport-authorized-clients',
//     require('./components/passport/AuthorizedClients.vue').default
// );

// Vue.component(
//     'passport-personal-access-tokens',
//     require('./components/passport/PersonalAccessTokens.vue').default
// );
import UploadFile from './Components/UploadFile.vue';
import CRUD from './Components/CRUD.vue';
import Clock from './Components/Clock.vue';
Vue.component('uploadFile', UploadFile);
Vue.component('crud', CRUD);
Vue.component('clock', Clock);

// Vue.component('auth-signup', require('./components/auth/signup.vue').default);
// Vue.component('auth-login', require('./components/auth/login.vue').default);
// Vue.component('auth-logout', require('./components/auth/logout.vue').default);

//vuex
import store from './store'

//i18n
import i18n from './i18n'


//router
import router from './router';

//auto-logout when the API reports the token is no longer valid
axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401 && error.response.data && error.response.data.message === 'Unauthenticated.') {
            localStorage.removeItem('user_token');
            localStorage.removeItem('user_token_expire');
            store.commit('token', { 'token': '', 'expire': '' });
            if (router.currentRoute.name !== 'login') {
                router.push({ name: 'login' });
            }
        }
        return Promise.reject(error);
    }
);

//Vue App
export const app = new Vue({
    el: '#app',
    store,
    router,
    i18n,
    data(){
        return {
            drawerLeft: false,
            windowHeight: 0,
            user:[],
            isMasquerading: false,
            unreadChatCount: 0,
            notificationTimer: null,
            pages: [
                {'title':'home','to':'home'},
                {'title':'login','to':'login','roles': ['visitor']}
            ]
        };
    },
    created: function(){
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
        // window.addEventListener('storage', this.handleStorage;
        this.handleStorage();            
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
        this.stopNotificationPolling();
    },
    methods: {
        returnToAdmin() {
            if (localStorage.getItem('original_user_token')) {
                localStorage.setItem('user_token', localStorage.getItem('original_user_token'));
                localStorage.setItem('user_token_expire', localStorage.getItem('original_user_token_expire'));
                localStorage.removeItem('original_user_token');
                localStorage.removeItem('original_user_token_expire');
                window.location.href = '/';
            }
        },
        getLocale(){
            return i18n.locale
        },
        changeLang(lang){
            i18n.locale = lang
        },
        handleResize() {
            this.windowHeight = window.innerHeight - (window.innerHeight * 0.02);
        },
        loadUnreadChatCount() {
            if (!store.getters.token.token) {
                this.unreadChatCount = 0;
                return;
            }

            axios.get('api/v1/chat/unread-count').then((r) => {
                this.unreadChatCount = r.data.count || 0;
            }).catch(() => {
                this.unreadChatCount = 0;
            });
        },
        startNotificationPolling() {
            if (this.notificationTimer) return;
            this.loadUnreadChatCount();
            this.notificationTimer = setInterval(this.loadUnreadChatCount, 15000);
        },
        stopNotificationPolling() {
            if (this.notificationTimer) clearInterval(this.notificationTimer);
            this.notificationTimer = null;
        },
        openChat() {
            this.$router.push({ name: 'chat' });
        },
        handleStorage() {
            if (localStorage.getItem('original_user_token')) {
                this.isMasquerading = true;
            } else {
                this.isMasquerading = false;
            }
            if(localStorage.hasOwnProperty('user_token')){
                store.commit('token', {
                    'token':localStorage.getItem('user_token'),
                    'expire':localStorage.getItem('user_token_expire')
                });
                if(store.getters.token.token) window.axios.defaults.headers.common['Authorization'] = store.getters.token.token;
                this.startNotificationPolling();
                this.pages = [
                    {'title': this.$t('home') ,'to':'home'},
                    {'title': this.$t('profile') ,'to':'profile'},
                    {'title':'Chat','to':'chat'},
                    {'title':'Herrmann','to':'herrmann'},
                ];
                axios.get('api/auth/profile/show').then(r=>{
                    this.user = r.data
                    if(this.user.roles){
                        for (let index = 0; index < this.user.roles.length; index++) {
                            const element = this.user.roles[index];
                            if(element.name)
                                this.pages.push({'title': this.$t(element.name) ,'to': element.name})
                        }
                    }
                    this.pages.push({'title': this.$t('logout') ,'to':'logout'});
                });
            }
            else{
                this.stopNotificationPolling();
                this.unreadChatCount = 0;
                this.pages = [
                    {'title':'home','to':'home'},
                    {'title':'Herrmann','to':'herrmann'},
                    {'title':'login','to':'login','roles': ['visitor']}
                ];
            }
        }
    }
});
